import login from './login';

export default {
  language: 'hu-HU',
  country: 'hu',
  name: 'Magyar',
  embeddedLocale: login,
};
